import { render, staticRenderFns } from "./qualification-aggregate-nbn.vue?vue&type=template&id=580e4d5c&scoped=true"
import script from "./qualification-aggregate-nbn.vue?vue&type=script&lang=js"
export * from "./qualification-aggregate-nbn.vue?vue&type=script&lang=js"
import style0 from "./qualification-aggregate-nbn.vue?vue&type=style&index=0&id=580e4d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e4d5c",
  null
  
)

export default component.exports